var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ui modal", attrs: { id: "past-banquet-dialog" } },
    [
      _c("div", { staticClass: "scrolling content" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _vm.banquets.length > 0
          ? _c("table", { staticClass: "ui compact table" }, [
              _vm._m(2),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.banquets, function (banquet) {
                  return _c("tr", { key: banquet.id }, [
                    _c("td", [_vm._v(_vm._s(banquet.marunage.code))]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "a",
                        { attrs: { href: banquet.chat_url, target: "_blank" } },
                        [
                          banquet.chat && banquet.chat.unread_count > 0
                            ? _c("i", { staticClass: "green large talk icon" })
                            : _c("i", { staticClass: "large comment icon" }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          banquet.marunage.name_kana ||
                            banquet.marunage.name ||
                            "(未設定)"
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm._f("formatDate")(banquet.marunage.event_date)
                        ) +
                          " " +
                          _vm._s(banquet.marunage.event_time)
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(banquet.marunage.people_label))]),
                  ])
                }),
                0
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.directCalls.length > 0
          ? _c("div", { staticClass: "ui negative message" }, [
              _vm._v(
                "\n      折り返し対応が必要な宴会予約の電話案件がございます。"
              ),
              _c("br"),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticStyle: { color: "blue" },
                  attrs: {
                    href: "/shopadmin/banquets/direct_call?shop_status=initial",
                  },
                },
                [_vm._v("電話案件一覧")]
              ),
              _vm._v(
                "よりに記載の電話番号をご確認のうえ、速やかにご対応くださいますようお願いいたします。\n    "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._m(3),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "actions" }, [
        _c("div", { staticClass: "ui button", on: { click: _vm.close } }, [
          _vm._v("閉じる"),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: {
          "background-color": "red",
          color: "#fff",
          padding: "15px",
          margin: "-21px -21px 0 -21px",
        },
      },
      [
        _c("i", { staticClass: "fas fa-exclamation-triangle" }),
        _vm._v(" 重要なお知らせ\n    "),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ui negative message" }, [
      _vm._v("\n      ご宴会実施日を過ぎている案件がございます。"),
      _c("br"),
      _vm._v(
        "\n      至急ステータスの更新操作及び、ご利用金額の入力をお願いします。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v("\n      案件操作方法については"),
      _c(
        "a",
        {
          staticStyle: { color: "blue" },
          attrs: {
            href: "https://changeable-forgery-609.notion.site/1c92c84c9f83800bb7a6c0c9f7a41ebf",
            target: "_blank",
          },
        },
        [_vm._v("こちら")]
      ),
      _vm._v("をご確認ください。\n    "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("お問い合わせ番号")]),
        _vm._v(" "),
        _c("th", [_vm._v("チャット")]),
        _vm._v(" "),
        _c("th", [_vm._v("お名前（カナ）")]),
        _vm._v(" "),
        _c("th", [_vm._v("希望日時")]),
        _vm._v(" "),
        _c("th", [_vm._v("人数")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ui positive message" }, [
      _vm._v(
        "\n      操作に関してご不明点がある場合は、以下までご連絡ください。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v("\n      【グルメプラスサポート（株式会社オールフィット）】"),
      _c("br"),
      _vm._v("\n      メールアドレス：info@gourmetplus.jp"),
      _c("br"),
      _vm._v("\n      電話番号：0422-24-9496\n    "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }